/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Treatment/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Info from 'DesignSystem/Info/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Treatment({
  children,
  viewPath = "/App/Auth/SignUp/Instructions/Content/Treatment"
  
}) {
let dtColorsBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.base'
        })
let dtTypographyFontweightRegular = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontWeight.regular'
        })
  return (<React.Fragment
>
<Info
  viewPath={`${viewPath}/Info`}
 color={dtColorsBrandBase}
 textOverflow="none"
 whiteSpace="wrap"
 fontWeight={dtTypographyFontweightRegular}
 text="Thanks for accepting treatment! Time to create your Practice Hub account"
/>
{children}
</React.Fragment>)
}